const BaseOrganic = require('./common/base-organic');
const $ = require('cash-dom');
const DetectOS = require('./components/detect-os');
require('./components/vulnerability-tool/extras/extras');
const Ajax = require('./components/ajax');
const Cookie = require('js-cookie');
const Page = require('./components/page');
const Faq = require('./components/faq');
const StarsRatingAndFeedback = require('./components/stars-rating-and-feedback');

const VulnerabilityTool = {
    init() {
        const self = this;

        if (typeof construction === 'undefined') {
            console.error('Error: variable `construction` is not specified!');
            return;
        }

        if (typeof DetectOS === 'undefined') {
            console.error('Error: variable `AffiliateLinks` is not specified!');
            return;
        }

        if (typeof window.extras !== 'undefined') {
            construction['extras'] = window.extras;
        }

        setTimeout(function () {
            Ajax.post("/zerorose/user_data.php", construction, function (data) {
                self._handleUserData(data);
            }, "json");
        }, 3000);

        // to init affiliate links ASAP
        DetectOS.initAffiliateLinks().catch((error) => {
            console.error('init affiliateLinks error', error);
        });
    },

    _handleUserData(userData) {
        Ajax.post("/zerorose/result.php", userData, function (data) {
            var $h2 = $('#tool_check_result');
            var $holder = $('#vulnerabilities');
            var $filters = $('#vulnerability-tool #filters');

            $holder.html('');
            var resultStr = tr('We\'ve found {{x}} vulnerabilities on your device');

            resultStr = resultStr.replace('{{x}}', data.vulns.length);
            $h2.text(resultStr);

            if (data.vulns.length === 0) {
                $h2
                  .prepend('<i class="fas fa-thumbs-up"></i>')
                  .addClass('no-results');
            } else {
                Ajax.post(ajaxurl, {
                    action: 'vulnerability-tool-request',
                    request: userData,
                    vulnerabilities: data
                });

                var prevCheck = Cookie.get('vulnerability-tool-check');

                if (typeof prevCheck !== 'undefined' && prevCheck !== null) {
                    var minutesFromLastCheck = (((+new Date()) / 1000) - prevCheck) / 60;

                    if (minutesFromLastCheck >= 5 && minutesFromLastCheck < 180) {
                        $('#update-warning').show();
                        Cookie.set('vulnerability-tool-check', (+new Date()) / 1000);
                    }
                } else {
                    Cookie.set('vulnerability-tool-check', (+new Date()) / 1000);
                }
            }
            var counts = {};

            data.vulns = data.vulns.sort(function (a, b) {
                var a_val = a.severity === 'Critical' ? 3 : a.severity === 'High' ? 2 : 1;
                var b_val = b.severity === 'Critical' ? 3 : b.severity === 'High' ? 2 : 1;
                return b_val - a_val;
            });

            var vulnList = {};
            for (var v = 0; v < data.vulns.length; v++) {

                var vuln = data.vulns[v];
                var severity = vuln.severity.toLowerCase();
                var product_name = vuln.product_name;
                var product_key = product_name + '-' + vuln.product_version;

                if (typeof vulnList[product_key] === 'undefined') {
                    vulnList[product_key] = {
                        'name': product_name,
                        'version': vuln.product_version,
                        'vulnerabilities': {
                            'critical': [],
                            'high': [],
                            'medium': [],
                            'low': []
                        }
                    }
                }

                vulnList[product_key]['vulnerabilities'][severity].push(data.vulns[v]);


                if (typeof counts[severity] === 'undefined') {
                    counts[severity] = 0;
                }
                counts[severity]++;

                var $card = $('<div/>').attr({
                    'class': 'vulnerability severity-' + severity
                });

                var $cardInner = $('<div/>').attr({
                    'class': 'inner'
                });

                var $severity = $('<div/>').attr({
                    'class': 'severity'
                }).html(severity);

                var $product = $('<h3/>').attr({
                    'class': 'product'
                }).html(vuln.product_name + ' ' + vuln.product_version);

                var $desc = $('<div/>').attr({
                    'class': 'description'
                }).html(vuln.description);

                var fix_link = "https://www.google.com/?q=upgrade " + product_name;

                if (typeof fixes[product_name.toLowerCase()] !== 'undefined') {
                    fix_link = fixes[product_name.toLowerCase()];
                }

                var $btn = $('<a/>').attr({
                    'href': fix_link,
                    'target': '_blank',
                    'class': 'btn btn-primary'
                }).html('<i class="fas fa-wrench"></i> ' + tr('Fix'));

                $cardInner
                  .append($severity)
                  .append($product)
                  .append($desc)
                  .append($btn);

                $card.html($cardInner);
                //  $holder.append($card);

                if (v < 10) {
                    (function ($card) {
                        setTimeout(function () {
                            $card.css('opacity', 1);
                        }, v * 50);
                    })($card);
                } else {
                    $card.css('opacity', 1);
                }
            }

            for (var i in vulnList) {
                var p = vulnList[i];

                var total_vulnerabilities = p.vulnerabilities.critical.length + p.vulnerabilities.high.length + p.vulnerabilities.medium.length + p.vulnerabilities.low.length;
                var total_vulnerabilities_text = '<a href="#" class="vulnerabilities-ctrl">' + tr('{{x}} vulnerabilities').replace('{{x}}', total_vulnerabilities) + '</a>';

                if (p.vulnerabilities.critical.length > 0 || p.vulnerabilities.high.length > 0) {
                    var vulnerabilities_explanation = [];
                    if (p.vulnerabilities.critical.length > 0) {
                        vulnerabilities_explanation.push(p.vulnerabilities.critical.length + " " + tr("critical"));
                    }

                    if (p.vulnerabilities.high.length > 0) {
                        vulnerabilities_explanation.push(p.vulnerabilities.high.length + " " + tr("high"));
                    }

                    total_vulnerabilities_text += " (" + vulnerabilities_explanation.join(', ') + ")";
                }

                var $product = $("<div/>").attr({
                    'class': 'product-holder'
                }).html('<div class="pull-left"><h3>' + p.name + ' ' + p.version + '</h3>' + total_vulnerabilities_text + '</div>');

                var fix_link = "https://www.google.com/?q=upgrade " + p.name;
                if (typeof fixes[p.name.toLowerCase()] !== 'undefined') {
                    fix_link = fixes[p.name.toLowerCase()];
                }

                var $btn = $('<a/>').attr({
                    'href': fix_link,
                    'target': '_blank',
                    'class': 'btn btn-primary'
                }).html('<i class="fas fa-wrench"></i> ' + tr('Fix'));

                $product.append($btn);
                $product.append('<div class="clear"></div>');

                var $vulnerabilitiesDetails = $('<div/>').attr({
                    'class': 'vulnerabilities-details'
                });

                var severities = ['critical', 'high', 'medium', 'low'];
                for (var s in severities) {
                    for (var vu = 0; vu < p.vulnerabilities[severities[s]].length; vu++) {
                        var vulnerability = p.vulnerabilities[severities[s]][vu];

                        $vulnerabilitiesDetails.append('<p class="' + severities[s] + '"><strong>' + tr(vulnerability.severity.toLowerCase()) + ' <i>' + vulnerability.cve_id + '</i></strong>' + vulnerability.description + '</p>');
                    }
                }

                $product.append($vulnerabilitiesDetails);

                $holder.append($product);
            }


            for (var c in counts) {
                var $filter = $('<a/>').attr({
                    'class': 'severity-' + c,
                    'href': '#' + c
                }).html(tr(c) + '<span>' + counts[c] + '</span>');

                $filters.append($filter);
            }

            /*
            $filters.on('click', 'a', function (e) {
                e.preventDefault();

                var severity = $(this).attr('href').substr(1);
                var activeSeverity = '';

                if ($filters.find('a.active').length > 0) {
                    activeSeverity = $filters.find('a.active').attr('href').substr(1);
                    $filters.find('a.active').removeClass('active');
                }

                if (severity === activeSeverity) {
                    $('.vulnerability').show();
                } else {
                    $('.vulnerability.severity-' + severity).show();
                    $('.vulnerability:not(.severity-' + severity + ')').hide();

                    $(this).addClass('active');

                }
            });
            */

            $holder.find('.vulnerabilities-ctrl').on('click', function (e) {
                e.preventDefault();

                $(this).closest('.product-holder').find('.vulnerabilities-details').toggleClass('active');
            });

            if ($('#vulnerability-tool-feedback').length) {
                setTimeout(function () {
                    $('#vulnerability-tool-feedback').addClass('active');

                    $('#vulnerability-tool-feedback-close').on('click', function (e) {
                        e.preventDefault();

                        $('#vulnerability-tool-feedback').removeClass('active');
                    });

                    $('#vulnerability-tool-feedback-send').on('click', function (e) {
                        e.preventDefault();

                        var $textarea = $(this).parent().find('textarea');

                        if ($textarea.val() === '') {
                            $textarea.addClass('error');
                            return;
                        }

                        Page.startLoad('vulnerability-tool-feedback', '#vulnerability-tool-feedback');
                        Ajax.post(ajaxurl, {
                            'action': 'vulnerability-tool-feedback',
                            'feedback': $textarea.val()
                        }, function () {
                            $('#vulnerability-tool-feedback').removeClass('active');
                            Page.finishLoad('vulnerability-tool-feedback')
                        }, 'json');
                    });
                }, 3500);
            }

            DetectOS.initAffiliateLinks().then(() => {
                DetectOS.renderAffiliateLinks();
            }).catch((error) => {
                console.error('init affiliateLinks error', error);
            });

        }, "json");
    },
};

$(function () {
    BaseOrganic.init();
    VulnerabilityTool.init();
    Faq.init();
    StarsRatingAndFeedback.init();
});
